const EnterpriseFeatureCard = ({ icon: Icon, title, description }) => {
  return (
    <article className="group flex h-full flex-col items-center justify-center rounded-2xl border border-slate-200 bg-white p-6 text-center shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-cyan-200 hover:shadow-lg">
      <div className="mb-5 inline-flex h-11 w-11 items-center justify-center rounded-xl bg-cyan-50 text-cyan-700 transition-colors duration-300 group-hover:bg-cyan-100">
        <Icon size={20} strokeWidth={2.1} />
      </div>
      <h3 className="mb-2 text-lg font-semibold text-slate-900">{title}</h3>
      <p className="text-sm leading-relaxed text-slate-600">{description}</p>
    </article>
  );
};

export default EnterpriseFeatureCard;
